<table *ngIf="tableData">
  <thead
    num-table-header
    class="table-header sticky-header"
    [headers]="tableData.header.headers"
  ></thead>
  <tbody
    num-table-body
    [rows]="tableData.body.rows"
    (rowClicked)="rowClicked.emit($event)"
    (selectedRow)="selectedRow.emit($event)"
  ></tbody>
</table>
